import { sortByPredefinedOrder } from '../../../utils/shared/sortUtils';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';
import { KEY } from '../../../constants/shared/PMConstants';

const { PERIOD_KEY } = KEY;
const { DO, WR } = MEASURE;

export const parseCheckPoints = (checkPoints, toyPeriods) =>
    Object.keys(checkPoints).reduce((acc, grade) => {
        const gradeObject = {
            [grade]: sortByPredefinedOrder(checkPoints[grade], toyPeriods, PERIOD_KEY).reverse(),
        };
        return { ...acc, ...gradeObject };
    }, {});

export const parseSaveCheckPoints = (checkPoints, savedCheckpoint) => {
    const grade = Object.keys(savedCheckpoint)[0];
    if (checkPoints[grade]) {
        const { dates, period: savedPeriod } = savedCheckpoint[grade][0];
        const periodIndex = checkPoints[grade].findIndex(item => item.period === savedPeriod);

        const updatedCheckPoints = { ...checkPoints };
        if (periodIndex > -1) {
            updatedCheckPoints[grade][periodIndex].dates.unshift(dates[0]);
        } else {
            updatedCheckPoints[grade] = [
                {
                    period: savedPeriod,
                    dates,
                },
                ...updatedCheckPoints[grade],
            ];
        }

        return updatedCheckPoints;
    }

    return { ...checkPoints, ...savedCheckpoint };
};

export const parseObservations = observations =>
    observations.map(
        ({ observation_uid: id, observation_name: name, measure, description, parameters }) => ({
            id,
            name,
            // WR = DO, we get WR as a measure from API response, but DO is needed
            measure: measure === WR ? DO : measure,
            description,
            parameters,
        }),
    );
